import React from 'react';
import { ResponsiveBar } from 'cccisd-nivo/bar';

const ComponentChartBar = props => {
    const { targetLineValue, verticalScaleMin, verticalScaleMax, scoreSuffix, showLegend, showLabels, colorScheme } =
        props.settings;

    return (
        <div style={{ width: '100%', height: '300px', marginTop: '0.5em' }}>
            <ResponsiveBar
                data={props.data}
                colors={
                    colorScheme === 'highlightAboveBenchmark'
                        ? ['#7499C1', '#3674B5', '#275382', '#2F639C', '#234B75']
                        : { scheme: 'category10' }
                }
                colorBy={v => {
                    if (colorScheme === 'highlightAboveBenchmark') {
                        return v.value > targetLineValue;
                    }
                    return v.id;
                }}
                borderWidth={1}
                padding={0.2}
                groupMode="grouped"
                keys={['Session 1', 'Session 2', 'Session 3', 'Session 4', 'Session 4b', 'Session 5']}
                indexBy="metric"
                minValue={Number(verticalScaleMin) || 0}
                maxValue={Number(verticalScaleMax) || 100}
                axisLeft={{
                    format: n => `${n}${scoreSuffix}`,
                }}
                axisBottom={{
                    tickSize: 0,
                }}
                labelTextColor="#fff"
                labelFormat={value => `${value}${scoreSuffix}`}
                enableLabel={showLabels ? true : false}
                layers={
                    showLegend
                        ? ['grid', 'axes', 'bars', 'markers', 'legends', 'annotations']
                        : ['grid', 'axes', 'bars', 'markers', 'annotations']
                }
                markers={
                    targetLineValue
                        ? [
                              {
                                  axis: 'y',
                                  value: Number(targetLineValue) || 80,
                                  lineStyle: {
                                      stroke: '#b1cbe7',
                                      strokeWidth: 2,
                                      strokeDasharray: '10,5',
                                  },
                                  legend: '',
                                  legendOrientation: 'horizontal',
                              },
                          ]
                        : []
                }
            />
        </div>
    );
};

export default ComponentChartBar;
